import { UserPlan } from '@state/trash/types';

export const getSortedUpgradeUserPlansByPrice = (plans: UserPlan[]) =>
  plans.sort((planA, planB) => planA.price - planB.price);
